// Contrato de Compra (Termos 1.2): mesmo renderer de 16 idiomas de terms/privacy.

import { initLegalPageI18n } from '../utils/i18n/legalPageRenderer.js';

initLegalPageI18n({
    type: 'contract',
    containerSelector: '.legal-container',
    switcherSelector: '.lang-switcher',
    titleSelector: '.legal-header h1',
    backLinkSelector: '.back-link',
});
